import { defineMessage } from 'services/localization';

export const messages = {
    labelApprovers: defineMessage('count_plural_approver_other_approvers'),
    labelReviewers: defineMessage('count_plural_reviewer_other_reviewers'),
    helperText: defineMessage('count_type_didnt_make_a_xcluding_yourself_other'),
    nudgedText: defineMessage('we_have_nudged_count_type'),
    buttonNonNudged: defineMessage('nudge_type'),
    buttonNudged: defineMessage('timer_till_next_ping_action'),
};
